<template>
    <div>
        <div class="content-subtitle">
            <div class="breadcrumb-layout" style="padding: 10px 0;">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>信息管理</el-breadcrumb-item>
                    <el-breadcrumb-item>账号信息</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <el-form :model="userInfo" :rules="userRules" ref="userInfo" class="demo-ruleForm">
            <div class="form-row spacing">
                <div class="form-label">
                    <label class="required">昵称</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="nickName">
                        <el-input v-model="userInfo.nickName" :disabled="disabled"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-row spacing">
                <div class="form-label">
                    <label class="">性别</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-radio-group v-model="userInfo.gender" v-for="obj in gender">
                        <el-radio :label="obj.value" class="mr10" :disabled="disabled">{{obj.text}}</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-row spacing">
                <div class="form-label">
                    <label class="required">邮箱</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="email">
                        <el-input v-model="userInfo.email" :disabled="disabled"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-row spacing">
                <div class="form-label">
                    <label class="required">真实姓名</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="realName">
                        <el-input v-model="userInfo.realName" :disabled="disabled"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-toolbar">
                <el-button type="primary" id="updateBtn" @click="toUpdateUser();" class="swb-btn mb20 fl">修改</el-button>
                <el-button type="primary" id="saveBtn" @click="doUpdateUser();" class="swb-btn mb20 fl" style="display: none">保存</el-button>
                <el-button type="primary" id="cancelBtn" @click="cancelUpdate();" class="swb-btn mb20 fl" style="display: none">取消</el-button>
            </div>

        </el-form>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import userApi from '../../api/user'

    export default {
        name: 'swb-user-info',
        path: '/user/info',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '用户信息',
        notAsResc: true,
        authen: false,
        data: function () {
            let checkNickName = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入昵称'));
                } else {
                    callback();
                }
            };
            let checkEmail = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入邮箱'));
                } else {
                    if(!Utils.isEmail(value)) {
                        return callback(new Error('必须是邮箱'));
                    } else {
                        callback();
                    }
                }
            };
            let checkRealName = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入真实姓名'));
                } else {
                    callback();
                }
            };
            return {
                disabled: true,
                gender: [],
                userInfo: {},
                userRules: {
                    nickName: [{
                        validator: checkNickName,
                        trigger: 'blur'
                    }],
                    email: [{
                        validator: checkEmail,
                        trigger: 'blur'
                    }],
                    realName: [{
                        validator: checkRealName,
                        trigger: 'blur'
                    }],
                }
            }
        },
        created: function () {
            let self = this;
            let genderMale = getEnumInfoWith("gender", "name", 'Male');
            self.gender.push(genderMale);
            let genderFemale = getEnumInfoWith("gender", "name", 'Female');
            self.gender.push(genderFemale);
            let genderX = getEnumInfoWith("gender", "name", 'X');
            genderX.text = '保密';
            self.gender.push(genderX);
            self.getCurrentUser();
        },
        methods: {
            // 获取用户信息
            getCurrentUser: function () {
                let self = this;
                userApi.getUserByContext({}, function (result) {
                    if(result.type === "info") {
                        self.userInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 修改用户信息
            toUpdateUser: function () {
                let self = this;
                self.disabled = false;
                $('#updateBtn').css('display', 'none');
                $('#saveBtn').css('display', 'block');
                $('#cancelBtn').css('display', 'block');
            },
            // 取消修改
            cancelUpdate: function () {
                let self = this;
                self.disabled = true;
                $('#updateBtn').css('display', 'block');
                $('#saveBtn').css('display', 'none');
                $('#cancelBtn').css('display', 'none');
                self.getCurrentUser();
            },
            // 保存用户信息
            doUpdateUser: function () {
                let self = this;
                self.$refs.userInfo.validate(function (valid) {
                    if(valid) {
                        //
                        let postData = self.userInfo;
                        userApi.updateUser(postData, function (result, jqXhr) {
                            if(result.type == "info") {
                                self.disabled = true;
                                $('#updateBtn').css('display', 'block');
                                $('#saveBtn').css('display', 'none');
                                $('#cancelBtn').css('display', 'none');
                                MsgBox.success("修改成功");
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/user/UserInfo.vue